{
  "resourceType": "Medication",
  "id": "e8h2QLuf9R4UG31qMYcEj.s0KDKLkuZXngioDnhuThhu2GGRsU.DdKYSujDSVmnCI3",
  "code": {
    "coding": [
      { "system": "urn:oid:2.16.840.1.113883.6.253", "code": "42025" },
      { "system": "urn:oid:2.16.840.1.113883.6.68", "code": "07000020112008" },
      { "system": "urn:oid:2.16.840.1.113883.6.162", "code": "00328" },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "310473"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "1596450"
      },
      {
        "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
        "code": "1870193"
      }
    ],
    "text": "gentamicin IVPB 80 mg (premix)"
  },
  "form": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.0.1.7.4.698288.310",
        "code": "SOLN",
        "display": "solution"
      }
    ],
    "text": "solution"
  },
  "ingredient": [
    {
      "itemCodeableConcept": {
        "coding": [
          { "system": "urn:oid:2.16.840.1.113883.6.253", "code": "42025" },
          {
            "system": "urn:oid:2.16.840.1.113883.6.68",
            "code": "07000020112008"
          },
          { "system": "urn:oid:2.16.840.1.113883.6.162", "code": "00328" },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "310473"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "1596450"
          },
          {
            "system": "http://www.nlm.nih.gov/research/umls/rxnorm",
            "code": "1870193"
          }
        ],
        "text": "gentamicin IVPB 80 mg (premix)"
      }
    }
  ]
}
